import React, { useState } from 'react'
import { Button, Row, Col, Form, Spinner } from 'react-bootstrap'

import useFormvalidation from '../../validations/FormValidation'
import { ContactFormRules } from "../../validations/FormValidationRules";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { useMediaQuery } from 'react-responsive';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaRegCalendar } from "react-icons/fa";
import Apis from '../../services/Apis'
import { useSearchParams } from "react-router-dom";

const ContactForm = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
    const [searchParams] = useSearchParams();
    const utm_source = searchParams.get("utm_source") || "";
    const utm_medium = searchParams.get("utm_medium") || "";
    const utm_campaign = searchParams.get("utm_campaign") || "";
    const utm_term = searchParams.get("utm_term") || "";
    const {
        saveContactFormdata,
        // saveContactFormdataSecond,
    } = Apis();
    const [date, setDate] = useState(null);
    const [loader, setLoader] = useState(false)
    const [checked, setChecked] = useState(false);
    const [formValues, setFormValues] = useState(
        {
            "name": "",
            "phone": "",
            "email": "",
            "message": "",
            "source": "",
        }
    );

    const notify = (msz) => {
        toast(msz)
    }

    // const handleNext = async () => {
    //     setLoader(true);
    //     if (!checked) {
    //         setErrors({
    //             ...errors,
    //             checkbox: "Please accept the authorization consent",
    //         });

    //         setLoader(false);
    //         return;
    //     }
    //     try {
    //         const payload = {
    //             ...values,
    //         };

    //         const [response1, response2] = await Promise.all([
    //             saveContactFormdata(payload),
    //             // saveContactFormdataSecond(payload),
    //         ]);

    //         if (response1.status === 200 && response2.status === 200) {
    //             notify(response1.data);

    //             setValues({
    //                 name: "",
    //                 phone: "",
    //                 email: "",
    //                 subject: "",
    //                 source: "",
    //             });

    //             setDate(null);
    //         }
    //     } catch (error) {
    //         console.error(error);

    //         notify("Something went wrong");

    //         setValues({
    //             name: "",
    //             phone: "",
    //             email: "",
    //             subject: "",
    //             source: "",
    //         });
    //     } finally {
    //         setLoader(false);
    //     }
    // };
    const handleNext = async () => {
        setLoader(true);

        if (!checked) {
            setErrors({
                ...errors,
                checkbox: "Please accept the authorization consent",
            });
            setLoader(false);
            return;
        }

        try {
            const payload = {
                ...values,
                country: "India",
                utm_source,
                utm_medium,
                utm_campaign,
                utm_term,
            };

            //  Only ONE API call
            const response = await saveContactFormdata(payload);

            if (response.status === 200) {
                notify(response.data);

                setValues({
                    name: "",
                    phone: "",
                    email: "",
                    subject: "",
                    source: "",
                });

                setDate(null);
            }
        } catch (error) {
            console.error(error);
            notify("Something went wrong");

            setValues({
                name: "",
                phone: "",
                email: "",
                subject: "",
                source: "",
            });
        } finally {
            setLoader(false);
        }
    };

    const { values, setValues, errors, setErrors, handleChange, handleSubmit } = useFormvalidation(
        handleNext,
        ContactFormRules,
        formValues
    );

    const handleDate = (data) => {
        const formattedDate = moment(data).format('MM/DD/YYYY'); // Format the selected date
        setValues(values => ({ ...values, message: "Schedule Date is : " + formattedDate, source: "Aspiration" }));
        setDate(formattedDate)
    }


    return (
        <>
            <Row className={`${!isMobile ? 'mb-4' : ''}`} style={{ paddingRight: isMobile ? '' : '' }}>
                <Col lg={6} md={12} xs={12} className={`${isMobile ? 'mb-3' : ''}`}>
                    <Form.Control type="text" placeholder="Name" name="name" onChange={handleChange} value={values.name} autoComplete="new-item" />
                    <span className='error mt-3'>{errors.hasOwnProperty('name') &&
                        <><AiOutlineExclamationCircle className="error-icon" style={{ marginRight: '6px' }} />{errors.name} </>}
                    </span>
                </Col>
                <Col lg={6} md={12} xs={12} className={`${isMobile ? 'mb-3' : ''}`}>
                    <Form.Control type="email" placeholder="Email" name="email" onChange={handleChange} value={values.email} autoComplete="new-item" />
                    <span className='error mt-3'>{errors.hasOwnProperty('email') &&
                        <><AiOutlineExclamationCircle className="error-icon" style={{ marginRight: '6px' }} />{errors.email} </>}
                    </span>
                </Col>
            </Row>
            <Row style={{ paddingRight: isMobile ? '' : '' }}>
                <Col lg={6} md={12} xs={12} className={`${isMobile ? 'mb-3' : ''}`}>
                    <Form.Control
                        type="tel"
                        placeholder="+91 Phone Number"
                        name="phone"
                        value={values.phone}
                        autoComplete="new-item"
                        maxLength={10}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");

                            if (value.length <= 10) {
                                setValues({
                                    ...values,
                                    phone: value,
                                });

                                // remove error while typing
                                if (value.length === 10) {
                                    setErrors({
                                        ...errors,
                                        phone: "",
                                    });
                                }
                            }
                        }}
                        onBlur={() => {
                            if (values.phone.length !== 10) {
                                setErrors({
                                    ...errors,
                                    phone: "Phone number must contain 10 digits",
                                });
                            }
                        }}
                    />
                    <span className='error mt-3'>{errors.phone &&
                        <><AiOutlineExclamationCircle className="error-icon" style={{ marginRight: '6px' }} />{errors.phone} </>}
                    </span>
                </Col>
                <Col lg={6} md={12} xs={12}>
                    <div className='datepicker-container'>
                        <DatePicker selected={date ? new Date(date) : null} onChange={handleDate} className='custom-datepicker' placeholderText="Select Date" />
                        <FaRegCalendar className="calendar-icon" />
                    </div>
                    <span className='error mt-3'>{errors.hasOwnProperty('message') &&
                        <><AiOutlineExclamationCircle className="error-icon" style={{ marginRight: '6px' }} />{errors.message} </>}
                    </span>
                </Col>
            </Row>
            <Row className={`${isMobile ? 'mt-4' : 'mt-5'}`}>
                <Col>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexCheckChecked"
                            checked={checked}
                            onChange={(e) => {
                                setChecked(e.target.checked);

                                if (e.target.checked) {
                                    setErrors({
                                        ...errors,
                                        checkbox: "",
                                    });
                                }
                            }}
                        />
                        <label className="form-check-label authorize-label" htmlFor="flexCheckChecked">
                            I authorize representatives of IRA Aspiration to Call, SMS, Email or WhatsApp me about its products and offers. This consent overrides any registration for DNC/NDNC.
                        </label>
                        <span className='error mt-2 d-block'>
                            {errors.checkbox &&
                                <>
                                    <AiOutlineExclamationCircle
                                        className="error-icon"
                                        style={{ marginRight: '6px' }}
                                    />
                                    {errors.checkbox}
                                </>
                            }
                        </span>
                    </div>
                </Col>
            </Row>
            <button type="submit" className='common-btn1 schedule-button mt-3' onClick={handleSubmit}>Schedule a Visit {loader && <Spinner className='loader' animation="border" />}</button>
            <ToastContainer />
        </>
    )
}

export default ContactForm